import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppData } from '@hellodarwin/core/lib/features/providers/app-data-provider';
import { usePlatform } from '@hellodarwin/core/lib/features/providers/platform-provider';
import HdLogo from '@hellodarwin/icons/dist/icons/HdLogo';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from 'styled-components';
import LanguageSwitcher from './language-switcher';
import NavigationMenuItem from './menu-item';
import PremiumStatusBlock from './premium-status-block';
import Socials from './socials';
import { getAppTheme, Navigation, NavigationBrandLink, NavigationBrandLogo, } from './styles';
const DesktopNavigation = ({ links, handleLanguageChange, defaultOpen, company, contact, admin, openMeetingModalClicked, showPremiumStatus = true, }) => {
    const theme = useTheme();
    const { app } = usePlatform();
    const { navCollapsed } = useAppData();
    const appTheme = getAppTheme(theme);
    const [selectedKeys, setSelectedKeys] = useState(() => {
        if (defaultOpen) {
            return links
                .filter((i) => { var _a; return !!((_a = i.subLinks) === null || _a === void 0 ? void 0 : _a.length); })
                .map((itm) => itm.pathname);
        }
        return [];
    });
    useEffect(() => {
        if (navCollapsed) {
            setSelectedKeys([]);
        }
        else if (defaultOpen) {
            setSelectedKeys(links.filter((i) => { var _a; return !!((_a = i.subLinks) === null || _a === void 0 ? void 0 : _a.length); }).map((itm) => itm.pathname));
        }
    }, [navCollapsed]);
    return (_jsxs(Navigation, { "$open": !navCollapsed, onMouseLeave: navCollapsed ? () => setSelectedKeys([]) : undefined, children: [_jsxs("div", { children: [_jsxs(NavigationBrandLink, { as: Link, to: "/", "$open": !navCollapsed, "aria-label": "helloDarwin", children: [_jsx(NavigationBrandLogo, { "$visible": !navCollapsed, children: _jsx(HdLogo, { backgroundType: appTheme.logoBackgroundType, type: "primary", color: "b/w", width: 143, height: 18 }) }), _jsx(NavigationBrandLogo, { "$visible": navCollapsed, "$compact": true, children: _jsx(HdLogo, { backgroundType: appTheme.logoBackgroundType, type: "tertiary", color: "b/w", width: 28, height: 30 }) })] }), React.Children.toArray(links
                        .filter((link) => !link.hide)
                        .map((link) => (_jsx(NavigationMenuItem, Object.assign({}, link, { selectedKeys: selectedKeys, setSelectedKeys: setSelectedKeys }))))), app === 'client' && !navCollapsed && showPremiumStatus && (_jsx(PremiumStatusBlock, { company: company, contact: contact, admin: admin, openMeetingModalClicked: openMeetingModalClicked }))] }), app === 'admin' ? (_jsx(LanguageSwitcher, { handleLanguageChange: handleLanguageChange })) : (_jsx(Socials, { minimize: navCollapsed }))] }));
};
export default DesktopNavigation;
